import { menuBarV2ContentConst } from './menuBarContentConst';

/**
 * menuBarV2ContentConst의 키를 기반으로 메뉴바 상수를 생성합니다.
 * '소개', '요금제', '서비스', '소식', '문의하기' 순서를 따르거나
 * menuBarV2ContentConst에 정의된 순서대로 생성됩니다.
 */
export const menuBarV2Const = Object.keys(menuBarV2ContentConst).map(
  (title) => {
    const menuGroup = menuBarV2ContentConst[title];
    // sections 배열의 첫 번째 항목의 path를 사용하거나, 그룹 내 로직에 따라 path 결정
    // 기존 로직: menuBarV2ContentConst['소개'][0].path
    // 보통 첫번째 객체의 path나 sections[0]의 path를 사용

    let path = '#';
    if (menuGroup && menuGroup.length > 0) {
      if (menuGroup[0].path) {
        path = menuGroup[0].path;
      } else if (menuGroup[0].sections && menuGroup[0].sections.length > 0) {
        path = menuGroup[0].sections[0].path;
      }
    }

    return {
      title,
      path,
    };
  }
);
